module.exports = __webpack_public_path__ + "static/media/btn-copy.c7553fea.svg";